__turbopack_context__.v({
  "p": "P-module__O-Z_Ja__p",
});
